var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 205,
    viewBox: "0 0 206 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.049,
    cy: 41.5156,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.976,
    cy: 59.1768,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.456,
    cy: 68.2462,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.069,
    cy: 98.3181,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.308,
    cy: 100.347,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.566 100.347C167.566 137.155 137.462 167.009 100.308 167.009C63.1536 167.009 33.0493 137.155 33.0493 100.347C33.0493 63.539 63.1536 33.6853 100.308 33.6853C137.462 33.6853 167.566 63.539 167.566 100.347Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.61489,
    cy: 69.6784,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.1662,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.6701,
    cy: 192.83,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.95,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.697,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 128.47,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.854,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 174.293,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.568,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 180.26,
    cy: 123.617,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 184.079,
    cy: 93.5446,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 191.955,
    cy: 77.3156,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 186.466,
    cy: 40.7996,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.8159,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.6865,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 44.4599,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 13.4331,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 20.3545,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.69333,
    cy: 94.4994,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.5478,
    cy: 64.6665,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 25.3667,
    cy: 22.4226,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.8823,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 108.422,
    cy: 24.8093,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.436,
    cy: 18.8425,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.475 150.347C169.421 150.347 168.566 149.493 168.566 148.438C168.566 147.384 169.421 146.529 170.475 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51221 117.65C7.5667 117.65 8.42153 116.795 8.42153 115.741C8.42153 114.686 7.5667 113.831 6.51221 113.831",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5317 22.4228C75.5862 22.4228 76.4411 21.5679 76.4411 20.5134C76.4411 19.459 75.5862 18.6041 74.5317 18.6041",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.833 15.7399C119.779 15.7399 118.924 16.5948 118.924 17.6493C118.924 18.7038 119.779 19.5586 120.833 19.5586",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3306 166.934H16.2972M26.3211 155.836V157.388M38.0157 166.934H39.5671M26.3211 176.481V178.271M26.3211 180.658V186.982M21.9058 166.934C24.8892 166.934 26.4405 162.638 26.4405 162.638C26.4405 162.638 26.9178 166.934 30.7365 166.934C29.0181 166.934 26.5598 168.486 26.3211 171.588C26.3211 171.588 26.0432 169.048 25.1278 168.128C24.3635 167.359 21.9058 166.934 21.9058 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.709 30.0597L172.742 30.0597M162.599 45.8116L162.718 39.6063M151.024 30.0597L149.472 30.0597M162.599 20.7518L162.599 8.57985M167.134 30.0597C164.15 30.0597 162.599 34.3557 162.599 34.3557C162.599 34.3557 162.122 30.0597 158.303 30.0597C160.021 30.0597 162.48 28.5084 162.718 25.4057C162.718 25.4057 162.996 27.9459 163.912 28.8664C164.676 29.635 167.134 30.0597 167.134 30.0597Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 71.1826,
    width: 96,
    height: 64.1111,
    rx: 9,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 71.1826,
    width: 96,
    height: 36.1111,
    rx: 9,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1665 67.0714V62.1825C84.1665 58.8688 86.8528 56.1825 90.1665 56.1825H111.611C114.925 56.1825 117.611 58.8688 117.611 62.1825V66.4774",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6113 67.0713V64.6268C89.6113 62.97 90.9545 61.6268 92.6113 61.6268H109.167C110.824 61.6268 112.167 62.97 112.167 64.6268V66.7743",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0552,
    y: 98.4049,
    width: 12.7778,
    height: 17.4444,
    rx: 6.38889,
    fill: "#F2F3F4",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.408 101C147.263 101 133.108 105.289 131.392 107.005C129.676 108.721 130.963 126.479 130.963 130.597C130.963 134.715 133.251 138.89 134.395 140.462C137.826 143.608 144.689 149.899 146.834 151.615C148.979 153.331 151.552 152.902 152.839 151.615C154.126 150.328 159.922 146.876 163.134 142.607C166.56 138.054 168.853 132.17 169.139 129.31C169.425 126.45 169.568 108.721 168.281 107.005C166.994 105.289 151.552 101 149.408 101Z",
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.86 126.455C155.436 125.713 154.799 125.069 153.965 124.538C153.182 124.04 151.999 123.545 150.347 123.024C148.597 122.472 147.789 121.979 147.421 121.663C146.988 121.292 146.778 120.762 146.778 120.045C146.778 119.292 147.018 118.718 147.512 118.288C148.023 117.842 148.756 117.625 149.751 117.625C150.7 117.625 151.415 117.893 151.938 118.443C152.494 119.029 152.764 119.828 152.764 120.887C152.764 121.403 153.215 121.822 153.772 121.822H155.346C155.903 121.822 156.355 121.403 156.355 120.887C156.355 119.041 155.846 117.541 154.844 116.427C154.146 115.652 153.254 115.101 152.18 114.78C151.762 114.655 151.474 114.3 151.474 113.891V112.936C151.474 112.419 151.022 112 150.465 112H149.116C148.559 112 148.108 112.419 148.108 112.936V113.866C148.108 114.28 147.812 114.642 147.384 114.761C146.366 115.042 145.501 115.516 144.8 116.175C143.73 117.182 143.187 118.495 143.187 120.077C143.187 121.584 143.683 122.841 144.662 123.813C145.595 124.74 147.109 125.5 149.262 126.126C151.076 126.709 151.886 127.221 152.247 127.549C152.683 127.946 152.896 128.455 152.896 129.108C152.896 129.833 152.633 130.379 152.068 130.824C151.462 131.302 150.673 131.534 149.658 131.534C148.483 131.534 147.614 131.265 147.002 130.713C146.397 130.168 146.104 129.406 146.104 128.384C146.104 127.867 145.652 127.448 145.095 127.448H143.508C142.951 127.448 142.5 127.867 142.5 128.384C142.5 130.239 143.085 131.74 144.239 132.845C145.041 133.612 146.068 134.144 147.305 134.436C147.752 134.542 148.068 134.912 148.068 135.341V136.064C148.068 136.581 148.52 137 149.076 137H150.413C150.97 137 151.421 136.581 151.421 136.064V135.297C151.421 134.875 151.729 134.511 152.168 134.397C153.227 134.119 154.122 133.651 154.842 132.996C155.942 131.995 156.5 130.679 156.5 129.083C156.5 128.082 156.285 127.197 155.86 126.455Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    transform: "translate(85.5 90)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 120.843C98.1677 120.843 94.5666 119.349 91.8565 116.643C89.1464 113.937 87.6572 110.332 87.6572 106.5C87.6572 102.668 89.1505 99.0667 91.8565 96.3566C94.5625 93.6465 98.1677 92.1573 102 92.1573C105.832 92.1573 109.433 93.6506 112.143 96.3566C114.853 99.0626 116.342 102.668 116.342 106.5C116.342 110.332 114.849 113.933 112.143 116.643C109.437 119.353 105.832 120.843 102 120.843ZM102 92.3223C98.2131 92.3223 94.6532 93.7991 91.9761 96.4762C89.299 99.1533 87.8222 102.713 87.8222 106.5C87.8222 110.287 89.299 113.847 91.9761 116.524C94.6532 119.201 98.2131 120.678 102 120.678C105.787 120.678 109.346 119.201 112.024 116.524C114.701 113.847 116.177 110.287 116.177 106.5C116.177 102.713 114.701 99.1533 112.024 96.4762C109.346 93.7991 105.787 92.3223 102 92.3223Z",
    fill: "#787E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 117.068C99.1782 117.068 96.5258 115.971 94.5293 113.975C92.5328 111.978 91.4355 109.326 91.4355 106.504C91.4355 103.683 92.5328 101.03 94.5293 99.0338C96.5258 97.0373 99.1782 95.9401 102 95.9401C104.821 95.9401 107.474 97.0373 109.47 99.0338C111.467 101.03 112.564 103.683 112.564 106.504C112.564 109.326 111.467 111.978 109.47 113.975C107.474 115.971 104.821 117.068 102 117.068ZM102 96.0968C99.2194 96.0968 96.6083 97.1776 94.6448 99.1452C92.6813 101.109 91.5964 103.72 91.5964 106.5C91.5964 109.28 92.6772 111.891 94.6448 113.855C96.6083 115.818 99.2194 116.903 102 116.903C104.78 116.903 107.391 115.823 109.355 113.855C111.318 111.891 112.403 109.28 112.403 106.5C112.403 103.72 111.322 101.109 109.355 99.1452C107.391 97.1817 104.78 96.0968 102 96.0968Z",
    fill: "#787E8C",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 110.596C99.7389 110.596 97.9033 108.761 97.9033 106.5C97.9033 104.24 99.7389 102.404 101.999 102.404C104.26 102.404 106.096 104.24 106.096 106.5C106.096 108.761 104.26 110.596 101.999 110.596ZM101.999 102.569C99.8338 102.569 98.0683 104.334 98.0683 106.5C98.0683 108.666 99.8338 110.431 101.999 110.431C104.165 110.431 105.931 108.666 105.931 106.5C105.931 104.334 104.165 102.569 101.999 102.569Z",
    fill: "#787E8C",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M108.336 109.07C112.022 109.07 115.01 106.082 115.01 102.396C115.01 98.7096 112.022 95.7214 108.336 95.7214C104.65 95.7214 101.662 98.7096 101.662 102.396C101.662 106.082 104.65 109.07 108.336 109.07Z",
    fill: "#787E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 120.843C98.1677 120.843 94.5666 119.349 91.8565 116.643C89.1464 113.937 87.6572 110.332 87.6572 106.5C87.6572 102.668 89.1505 99.0667 91.8565 96.3566C94.5625 93.6465 98.1677 92.1573 102 92.1573C105.832 92.1573 109.433 93.6506 112.143 96.3566C114.853 99.0626 116.342 102.668 116.342 106.5C116.342 110.332 114.849 113.933 112.143 116.643C109.437 119.353 105.832 120.843 102 120.843ZM102 92.3223C98.2131 92.3223 94.6532 93.7991 91.9761 96.4762C89.299 99.1533 87.8222 102.713 87.8222 106.5C87.8222 110.287 89.299 113.847 91.9761 116.524C94.6532 119.201 98.2131 120.678 102 120.678C105.787 120.678 109.346 119.201 112.024 116.524C114.701 113.847 116.177 110.287 116.177 106.5C116.177 102.713 114.701 99.1533 112.024 96.4762C109.346 93.7991 105.787 92.3223 102 92.3223Z",
    fill: "#787E8C",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M90.2682 107.333C89.4102 107.333 88.5811 107.449 87.7891 107.663C87.8551 108.459 87.9829 109.235 88.1727 109.99C88.8327 109.784 89.5381 109.672 90.2682 109.672C94.1539 109.672 97.3054 112.824 97.3054 116.709C97.3054 117.782 97.0662 118.801 96.6331 119.712C97.3549 120.005 98.1098 120.244 98.8853 120.418C99.3762 119.279 99.6484 118.029 99.6484 116.713C99.6443 111.532 95.4451 107.333 90.2682 107.333Z",
    fill: "#787E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.448 96.794C111.454 95.7256 110.303 94.8099 109.024 94.088C109.808 94.8882 110.295 95.9814 110.295 97.19C110.295 99.6361 108.315 101.616 105.869 101.616C103.423 101.616 101.443 99.6361 101.443 97.19C101.443 94.7521 103.41 92.7762 105.844 92.7639C104.623 92.4215 103.332 92.24 102.004 92.24C101.839 92.24 101.674 92.2441 101.509 92.2482C100.143 93.4569 99.2812 95.2224 99.2812 97.19C99.2812 100.832 102.231 103.782 105.873 103.782C109.515 103.782 112.465 100.832 112.465 97.19C112.461 97.058 112.452 96.926 112.448 96.794Z",
    fill: "#787E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4005 103.699C90.0787 103.699 89.7776 103.505 89.6497 103.192C89.5672 102.99 89.5713 102.771 89.658 102.573C89.7446 102.375 89.9013 102.222 90.0993 102.14C90.5118 101.975 90.9862 102.177 91.1512 102.589C91.2337 102.792 91.2296 103.01 91.143 103.208C91.0563 103.406 90.8996 103.559 90.7016 103.641C90.6026 103.678 90.4995 103.699 90.4005 103.699ZM90.3963 102.247C90.318 102.247 90.2355 102.264 90.1571 102.292C89.9962 102.358 89.8725 102.478 89.8065 102.639C89.7405 102.796 89.7363 102.973 89.8023 103.13C89.9343 103.46 90.3097 103.621 90.6397 103.489C90.8006 103.423 90.9243 103.303 90.9903 103.142C91.0563 102.985 91.0605 102.808 90.9945 102.651C90.8955 102.4 90.6521 102.247 90.3963 102.247Z",
    fill: "#787E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.604 110.938C113.282 110.938 112.981 110.744 112.853 110.431C112.77 110.229 112.774 110.01 112.861 109.812C112.948 109.614 113.104 109.462 113.302 109.379C113.715 109.214 114.189 109.412 114.354 109.829C114.519 110.241 114.321 110.716 113.905 110.881C113.806 110.918 113.703 110.938 113.604 110.938ZM113.599 109.486C113.521 109.486 113.439 109.503 113.36 109.532C113.199 109.598 113.076 109.717 113.01 109.878C112.944 110.035 112.939 110.212 113.005 110.369C113.137 110.699 113.513 110.86 113.843 110.728C114.173 110.596 114.334 110.221 114.202 109.891C114.099 109.639 113.855 109.486 113.599 109.486Z",
    fill: "#787E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.302 102.078C97.2649 102.078 97.2277 102.078 97.1865 102.074C96.8977 102.045 96.642 101.905 96.4605 101.678C96.279 101.451 96.1965 101.17 96.2254 100.886C96.2542 100.601 96.3945 100.341 96.6214 100.16C97.0834 99.7845 97.7681 99.8546 98.1435 100.317C98.325 100.539 98.4075 100.824 98.3786 101.109C98.3497 101.393 98.2095 101.653 97.9826 101.835C97.7887 101.991 97.5495 102.078 97.302 102.078ZM97.2979 100.077C97.0875 100.077 96.8854 100.147 96.7204 100.284C96.5306 100.436 96.411 100.659 96.3862 100.902C96.3615 101.146 96.4316 101.385 96.5842 101.575C96.7369 101.764 96.9596 101.884 97.203 101.909C97.4464 101.934 97.6856 101.863 97.8754 101.711C98.0651 101.558 98.1847 101.335 98.2095 101.092C98.2342 100.849 98.1641 100.609 98.0115 100.42C97.8589 100.23 97.6361 100.11 97.3927 100.086C97.3639 100.081 97.3309 100.077 97.2979 100.077Z",
    fill: "#787E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.414 113.306C106.101 113.306 105.787 113.17 105.573 112.906C105.391 112.683 105.309 112.399 105.338 112.114C105.367 111.829 105.507 111.57 105.734 111.388C106.196 111.013 106.88 111.083 107.256 111.545C107.631 112.007 107.561 112.692 107.099 113.067C106.893 113.228 106.654 113.306 106.414 113.306ZM106.41 111.31C106.208 111.31 106.002 111.376 105.833 111.516C105.441 111.834 105.379 112.411 105.697 112.807C106.014 113.203 106.592 113.261 106.988 112.943C107.38 112.626 107.441 112.048 107.124 111.652C106.942 111.425 106.678 111.31 106.41 111.31Z",
    fill: "#787E8C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 205,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolios);
export default __webpack_public_path__ + "static/media/portfolios.ed60c5e7041e615b9db262447640b05f.svg";
export { ForwardRef as ReactComponent };